import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M56.33 11.76C50.92 5 38.71 1 31.61 1C24.51 1 12.19 5 6.78 11.76C-2.91 23.87 3.69998 50.51 3.69998 50.51C3.69998 50.51 4.35998 28.93 11.63 22.55C17.82 17.11 23.5 19.2 31.56 19.2C39.62 19.2 45.3 17.12 51.49 22.55C58.76 28.94 59.42 50.51 59.42 50.51C59.42 50.51 66.02 23.87 56.33 11.76Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M26.5299 1.66992C26.5299 1.66992 24.7098 2.32992 25.3698 5.21992C25.3698 5.21992 23.8798 6.94992 25.1198 9.26992C25.1198 9.26992 23.5498 11.9099 25.6198 13.8099C25.6198 13.8099 23.9698 16.6999 26.6898 19.0099"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M17.9499 3.97998C17.9499 3.97998 15.3099 5.62998 16.6299 9.67998C16.6299 9.67998 14.9799 11.5 16.4599 13.89C16.4599 13.89 14.8099 16.86 17.6199 19.17"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M13.3998 6.61987C13.3998 6.61987 11.0898 7.44987 11.4998 10.9099C11.4998 10.9099 9.10979 12.9699 10.5898 15.6999C10.5898 15.6999 9.34977 17.3499 10.5098 18.9999C10.5098 18.9999 8.93979 21.1499 10.8398 23.6199"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M4.97985 14.3799C4.97985 14.3799 2.99987 17.6799 4.80987 20.9899C4.80987 20.9899 2.74988 23.2199 4.63988 25.6099C4.63988 25.6099 2.65987 28.7499 5.87987 31.5499"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M36.58 1.66992C36.58 1.66992 38.3999 2.32992 37.7399 5.21992C37.7399 5.21992 39.2299 6.94992 37.9899 9.26992C37.9899 9.26992 39.5599 11.9099 37.4899 13.8099C37.4899 13.8099 39.1399 16.6999 36.4199 19.0099"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M45.1699 3.97998C45.1699 3.97998 47.8099 5.62998 46.4899 9.67998C46.4899 9.67998 48.1399 11.5 46.6599 13.89C46.6599 13.89 48.3099 16.86 45.4999 19.17"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M49.71 6.61987C49.71 6.61987 52.0199 7.44987 51.6099 10.9099C51.6099 10.9099 54 12.9699 52.52 15.6999C52.52 15.6999 53.7599 17.3499 52.5999 18.9999C52.5999 18.9999 54.17 21.1499 52.27 23.6199"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M58.13 14.3799C58.13 14.3799 60.11 17.6799 58.3 20.9899C58.3 20.9899 60.36 23.2199 58.47 25.6099C58.47 25.6099 60.45 28.7499 57.23 31.5499"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
    </g>
  )
}
